export type IVoucherStates = 'ISSUED' | 'LEASED' | 'SHOP_MODE' | 'TERMINATED_WITH_OUT_LEASING' | 'TERMINATED';

export enum VoucherStates {
  ISSUED = 'ISSUED',
  LEASED = 'LEASED',
  SHOP_MODE = 'SHOP_MODE',
  TERMINATED_WITH_OUT_LEASING = 'TERMINATED_WITH_OUT_LEASING',
  TERMINATED = 'TERMINATED',
}
